import { createHttpClient } from '@/api/http';
import { serviceUrls } from '@/config/serviceUrls';
import { getAuthHeaders } from '../../../utils/apiHeaders';

const client = createHttpClient(serviceUrls.learning);

export type CourseProgressDTO = {
  course_id: string;
  completedPageIds: string[];
  lastPageId?: string | null;
  status?: 'not_started' | 'in_progress' | 'completed';
  completedCount?: number;
  totalPages?: number;
};

export async function getCourseProgress(courseId: string): Promise<CourseProgressDTO | null> {
  const res = await client.get(`/v1/learning/progress/course/${courseId}`);
  return res.data as CourseProgressDTO;
}

export async function patchLastPage(
  courseId: string,
  lastPageId: string
): Promise<CourseProgressDTO | null> {
  const res = await client.patch(`/v1/learning/progress/course/${courseId}`, { lastPageId });
  return res.data as CourseProgressDTO;
}

export async function completePage(
  courseId: string,
  pageId: string
): Promise<CourseProgressDTO | null> {
  const res = await client.post(`/v1/learning/progress/course/${courseId}/complete-page`, { pageId });
  return res.data as CourseProgressDTO;
}

export async function mergeProgress(
  courseId: string,
  completedPageIds: string[],
  lastPageId?: string
): Promise<CourseProgressDTO | null> {
  const body: Record<string, unknown> = { completedPageIds };
  if (lastPageId) body.lastPageId = lastPageId;
  const res = await client.patch(`/v1/learning/progress/course/${courseId}/merge`, body);
  return res.data as CourseProgressDTO;
}

export async function getGradeSummary(grade: number) {
  console.debug('[progress.getGradeSummary] request', { grade });
  const res = await client.get(`/v1/learning/progress/summary?grade=${grade}`);
  console.debug('[progress.getGradeSummary] response', { status: res.status, dataLength: Array.isArray(res.data) ? res.data.length : undefined });
  return res.data;
}

